import React from 'react';
import { Avatar, Box, CardHeader, useTheme } from '@mui/material';
import ModalDialog from '../../common/components/ModalDialog';
import { Connection } from '../types/connection-types';
import { resolveIcon, resolveSubtitle } from '../utils/connection-icon-utils';
import ConnectionFormSwitcher from './ConnectionFormSwitcher';

const ConnectionModal: React.FC<
  React.PropsWithChildren<ConnectionModalProps>
> = props => {
  const theme = useTheme();

  const { open, onClose, connection } = props;

  const modalHeader = connection.enabled
    ? 'Revoke login option'
    : 'Allow login option';

  const subtitle = resolveSubtitle(connection);

  return (
    <ModalDialog
      modalColor={theme.palette.info.main}
      aria-label={modalHeader}
      open={open}
      onClose={onClose}
      modalHeader={modalHeader}>
      <Box sx={{ flexGrow: 1, mb: 2 }}>
        <CardHeader
          avatar={
            <Avatar
              alt={connection.displayName}
              src={resolveIcon(connection.icons)}
            />
          }
          title={connection.displayName}
          subheader={subtitle}
        />
      </Box>
      <ConnectionFormSwitcher connection={connection} onClose={onClose} />
    </ModalDialog>
  );
};

interface ConnectionModalProps {
  open: boolean;
  connection: Connection;
  onClose: () => void;
}

export default ConnectionModal;
